import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  setPosition: ['position'],
  setPositionSuccess: null
});

export { Creators, Types };
